module.exports = __webpack_public_path__ + "img/492465503.1bf56df9.jpg";